import React from "react";
import { TextField } from "@shoptet/ui";
import { useTranslation } from "react-i18next";
import { ActiveTextsAssetLinesQueryT, SuggestionKindT } from "../../graphql/generated/graphql";

type PreviewPropsT = {
  activeTextAssetLines: NonNullable<NonNullable<ActiveTextsAssetLinesQueryT["organization"]>["activeTextsAssetLines"]>;
  kind: SuggestionKindT;
};

export const Preview = ({ activeTextAssetLines, kind }: PreviewPropsT) => {
  const { t } = useTranslation("translation", { keyPrefix: "Components.AssetLineActions" });
  const approvedAssetLines = activeTextAssetLines.filter(
    (assetLine) => (assetLine.kind as string) === (kind as string)
  );
  return (
    <div className="TextSelection">
      {approvedAssetLines.map((assetLine) => (
        <div key={assetLine.id} className="TextAssetLine-Content">
          <TextField label={t("Text asset line label")} value={assetLine.content} disabled labelHidden />
        </div>
      ))}
    </div>
  );
};
